import React from "react";
import { Stack, Typography } from "@mui/material";
import { CurrencyConverter, WEB_COLORS } from "@/lib/constants";
import { DividerComponent, PaperComponent } from "@/components";
import VerticalStepper from "./vertical-stepper";
import { useTranslations } from "next-intl";

const LoanStatusCard = ({ loanTitle, loanAmount, loanData, appId }) => {
  const t = useTranslations("Dashboard");
  return (
    <PaperComponent
      sx={{
        p: 2,
        height: "100%",
        borderRadius: 5,
        // maxWidth: { xs: 300 },
        minWidth: { xs: 300, sm: 400, md: 600 },
      }}
    >
      <Stack gap={1}>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          alignItems={{ xs: "flex-start", sm: "center" }}
          justifyContent={"space-between"}
          gap={{ xs: 1, sm: 2 }}
          px={{ xs: 0.5, sm: 1 }}
          py={{ xs: 0.5, sm: 0 }}
        >
          <Typography
            variant="h5"
            sx={{ fontSize: { xs: "1.25rem", sm: "1.5rem" } }}
          >
            {loanTitle}
          </Typography>
          <Typography
            variant="h5"
            fontWeight={"bold"}
            color={WEB_COLORS.primary}
            sx={{ fontSize: { xs: "1.25rem", sm: "1.5rem" } }}
          >
            {CurrencyConverter(loanAmount)}
          </Typography>
        </Stack>
        <DividerComponent orientation="horizontal" />
        <VerticalStepper loanData={loanData} appId={appId} />
      </Stack>
    </PaperComponent>
  );
};

export default LoanStatusCard;
